import { Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ShootingStar } from "@mynaui/icons-react";
import { Tool } from "@mynaui/icons-react";
import QuickActionCard from '../components/Quickactioncard';
import SectionHeader from '../components/Sectionheader';
import { quickActions } from '../data/dashboardMockData';
import { getAssetsByZone } from '../../assets/data/assetsMockData';
import AssignedAssets from '../components/Assignedasset';
import { useZone } from '../../../shared/context/ZoneContext';

const TechnicianDashboard = () => {
  const navigate = useNavigate();
  const { selectedZone } = useZone();
  const zoneAssets = getAssetsByZone(selectedZone);

  const handleQuickAction = (actionId) => {
    console.log('Quick action clicked:', actionId);
    navigate('/asset/1')
  };

  const handleAssetClick = (assetId) => {
    navigate(`/asset/${assetId}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: '#F5F7FA',
        minHeight: '100vh',
        py: { xs: 2, sm: 4 },
      }}
    >
      <Container maxWidth="xl">
        {/* Quick Actions Section */}
        <Box sx={{ mb: 5 }}>
          <SectionHeader icon={ShootingStar} title="Quick Actions" />
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
              },
              gap: 3,
            }}
          >
            {quickActions.map((action) => (
              <QuickActionCard
                key={action.id}
                action={action}
                onClick={() => handleQuickAction(action.id)}
              />
            ))}
            </Box>
        </Box>

        {/* Assigned Assets Section */}
        <Box>
          <SectionHeader icon={Tool} title="Assigned Work Orders(10)" />
          <AssignedAssets
            assets={zoneAssets}
            onAssetClick={handleAssetClick}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default TechnicianDashboard;